module.exports = __webpack_public_path__ + "static/Planet_1-2d444276c3bd6227f49cabe633ac0c73.png";